<!-- <button type="button" class="diagnostic-trigger-btn" (click)="captureDiagnostic()">
Diagnóstico
</button> -->

<ng-template #diagnosticModal>
  <div class="diagnostic-modal-body">
    <div class="diagnostic-modal-actions">
      <div class="flex align-items-center gap-2">
        <!-- <button type="button" class="btn btn-outline-primary btn-sm" (click)="copyDiagnostic()">Copiar JSON</button> -->
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="downloadDiagnostic()">
          Baixar JSON
        </button>
      </div>
      <span class="diagnostic-shortcut">Atalho: Ctrl + Shift + D</span>
    </div>

    @if (hasData) {
      <div class="diagnostic-summary">
        <section class="diagnostic-section">
          <h6 class="diagnostic-section-title">Contexto</h6>
          <div class="diagnostic-list">
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Data/Hora</span>
              <span class="diagnostic-item-value">{{
                diagnosticData.timestamp | date: 'dd/MM/yyyy HH:mm:ss'
              }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Sistema</span>
              <span class="diagnostic-item-value">{{ diagnosticData.system }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Ambiente</span>
              <span class="diagnostic-item-value">{{ diagnosticData.environment }}</span>
            </div>
            @if (diagnosticData.accessType) {
              <div class="diagnostic-item">
                <span class="diagnostic-item-label">Access Type</span>
                <span class="diagnostic-item-value">{{ diagnosticData.accessType }}</span>
              </div>
            }
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">URL</span>
              <span class="diagnostic-item-value">{{ diagnosticData.url }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Rota</span>
              <span class="diagnostic-item-value">{{
                getRouteBreadcrumb(diagnosticData.route)
              }}</span>
            </div>
            @if (diagnosticData.modals?.length) {
              <div class="diagnostic-item">
                <span class="diagnostic-item-label">Modais visíveis</span>
                <ul class="diagnostic-item-value diagnostic-item-list">
                  @for (modal of diagnosticData.modals; track modal) {
                    <li>
                      <span class="diagnostic-badge">Modal</span>
                      <span>{{
                        modal.title || modal.id || modal.classes || 'Sem identificador'
                      }}</span>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (diagnosticData.toasts?.length) {
              <div class="diagnostic-item">
                <span class="diagnostic-item-label">Toasts visíveis</span>
                <ul class="diagnostic-item-value diagnostic-item-list">
                  @for (toast of diagnosticData.toasts; track toast) {
                    <li>
                      <span class="diagnostic-badge">Toast</span>
                      <span>{{ toast.message || toast.title }}</span>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </section>
        <section class="diagnostic-section">
          <h6 class="diagnostic-section-title">Usuário</h6>
          <div class="diagnostic-list">
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Nome</span>
              <span class="diagnostic-item-value">{{ diagnosticData.user?.name || '—' }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">E-mail</span>
              <span class="diagnostic-item-value">{{ diagnosticData.user?.email || '—' }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">ID</span>
              <span class="diagnostic-item-value">{{ diagnosticData.user?.id || '—' }}</span>
            </div>
          </div>
        </section>
        @if (getEnvironmentSummary(); as envSummary) {
          @if (envSummary.length) {
            <section class="diagnostic-section">
              <h6 class="diagnostic-section-title">Configuração do ambiente</h6>
              <div class="diagnostic-list">
                @for (item of envSummary; track item) {
                  <div class="diagnostic-item">
                    <span class="diagnostic-item-label">{{ item.key }}</span>
                    <span class="diagnostic-item-value">{{ item.value }}</span>
                  </div>
                }
              </div>
            </section>
          }
        }
        <section class="diagnostic-section">
          <h6 class="diagnostic-section-title">Visão da tela</h6>
          <div class="diagnostic-list">
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Título</span>
              <span class="diagnostic-item-value">{{ diagnosticData.documentTitle }}</span>
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Dimensões</span>
              <span class="diagnostic-item-value"
                >{{ diagnosticData.screen?.width }} × {{ diagnosticData.screen?.height }} px (DPR
                {{ diagnosticData.screen?.devicePixelRatio }})</span
              >
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Scroll</span>
              <span class="diagnostic-item-value"
                >X: {{ diagnosticData.scrollPosition?.x }} • Y:
                {{ diagnosticData.scrollPosition?.y }}</span
              >
            </div>
            <div class="diagnostic-item">
              <span class="diagnostic-item-label">Elemento em foco</span>
              <span class="diagnostic-item-value">{{
                formatValue(diagnosticData.focusElement)
              }}</span>
            </div>
          </div>
        </section>
        <section class="diagnostic-section">
          <h6 class="diagnostic-section-title">Armazenamento</h6>
          <div class="diagnostic-storage">
            <div>
              <h6 class="diagnostic-subtitle">localStorage</h6>
              @if (getStoragePreview(diagnosticData.localStorage); as localPreview) {
                @if (localPreview.length) {
                  @for (entry of localPreview; track entry) {
                    <div class="diagnostic-storage-item">
                      <span class="diagnostic-item-label">{{ entry.key }}</span>
                      <span class="diagnostic-storage-value">{{ formatValue(entry.value) }}</span>
                    </div>
                  }
                  @if (hasStorageOverflow(diagnosticData.localStorage)) {
                    <div class="diagnostic-note">
                      +{{ getStorageOverflowCount(diagnosticData.localStorage) }} itens adicionais
                      no JSON completo
                    </div>
                  }
                } @else {
                  <div class="diagnostic-note">Sem itens registrados.</div>
                }
              }
            </div>
            <div>
              <h6 class="diagnostic-subtitle">sessionStorage</h6>
              @if (getStoragePreview(diagnosticData.sessionStorage); as sessionPreview) {
                @if (sessionPreview.length) {
                  @for (entry of sessionPreview; track entry) {
                    <div class="diagnostic-storage-item">
                      <span class="diagnostic-item-label">{{ entry.key }}</span>
                      <span class="diagnostic-storage-value">{{ formatValue(entry.value) }}</span>
                    </div>
                  }
                  @if (hasStorageOverflow(diagnosticData.sessionStorage)) {
                    <div class="diagnostic-note">
                      +{{ getStorageOverflowCount(diagnosticData.sessionStorage) }} itens adicionais
                      no JSON completo
                    </div>
                  }
                } @else {
                  <div class="diagnostic-note">Sem itens registrados.</div>
                }
              }
            </div>
          </div>
        </section>
        @if (getConsolePreview(diagnosticData.console?.recent); as consolePreview) {
          @if (consolePreview.length) {
            <section class="diagnostic-section">
              <h6 class="diagnostic-section-title">
                Console (últimos {{ consolePreview.length }})
              </h6>
              <div class="diagnostic-console">
                @for (entry of consolePreview; track entry) {
                  <div class="diagnostic-console-entry">
                    <div class="diagnostic-console-meta">
                      <span
                        class="diagnostic-console-level diagnostic-console-level-{{ entry.level }}"
                        >{{ entry.level }}</span
                      >
                      <span>{{ entry.timestamp | date: 'HH:mm:ss' }}</span>
                    </div>
                    <pre class="diagnostic-console-message">{{ formatValue(entry.args) }}</pre>
                    @if (entry.stack) {
                      <div class="diagnostic-console-stack">
                        <pre>{{ entry.stack }}</pre>
                      </div>
                    }
                  </div>
                }
              </div>
            </section>
          }
        }
        <div class="diagnostic-raw-json">
          <h6 class="diagnostic-section-title">JSON completo</h6>
          <pre class="diagnostic-json"><code>{{ diagnosticJson }}</code></pre>
        </div>
      </div>
    } @else {
      <div class="diagnostic-empty">
        Nenhum dado de diagnóstico disponível. Gere o diagnóstico novamente.
      </div>
    }

    <ng-template #storageEmpty>
      <div class="diagnostic-note">Sem itens registrados.</div>
    </ng-template>
  </div>
</ng-template>

<ng-template #diagnosticEmpty>
  <div class="diagnostic-empty">
    Nenhum dado de diagnóstico disponível. Gere o diagnóstico novamente.
  </div>
</ng-template>
